var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_469_58682",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    width: 26.6667,
    height: 26.6667,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_469_58682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 24.3185C11.1747 24.3185 9.79253 23.749 8.65365 22.6102C7.51476 21.4713 6.94531 20.0892 6.94531 18.4638V6.45524C6.94531 5.2859 7.36167 4.28488 8.1944 3.45218C9.0271 2.61948 10.0281 2.20312 11.1975 2.20312C12.3668 2.20312 13.3678 2.61948 14.2005 3.45218C15.0332 4.28488 15.4496 5.2859 15.4496 6.45524V17.2886C15.4496 18.0305 15.1934 18.6575 14.6811 19.1698C14.1688 19.682 13.5417 19.9382 12.7997 19.9382C12.0577 19.9382 11.4307 19.682 10.9186 19.1698C10.4065 18.6575 10.1505 18.0305 10.1505 17.2886V7.11763C10.1505 6.92627 10.213 6.76803 10.338 6.6429C10.463 6.51779 10.6211 6.45524 10.8123 6.45524C11.0035 6.45524 11.1618 6.51779 11.2872 6.6429C11.4125 6.76803 11.4752 6.92627 11.4752 7.11763V17.2886C11.4752 17.664 11.6022 17.9786 11.8561 18.2325C12.11 18.4864 12.4247 18.6134 12.8 18.6134C13.1754 18.6134 13.49 18.4864 13.7439 18.2325C13.9978 17.9786 14.1248 17.664 14.1248 17.2886V6.45524C14.1248 5.63557 13.8417 4.94276 13.2756 4.37682C12.7095 3.81086 12.0165 3.52787 11.1965 3.52787C10.3766 3.52787 9.68391 3.81086 9.11837 4.37682C8.55285 4.94276 8.27009 5.63557 8.27009 6.45524V18.4638C8.27009 19.7145 8.7124 20.7822 9.59701 21.6668C10.4816 22.5514 11.5493 22.9937 12.8 22.9937C14.0507 22.9937 15.1184 22.5514 16.003 21.6668C16.8876 20.7822 17.3299 19.7145 17.3299 18.4638V7.11763C17.3299 6.92627 17.3924 6.76803 17.5175 6.6429C17.6425 6.51779 17.8006 6.45524 17.9918 6.45524C18.183 6.45524 18.3413 6.51779 18.4666 6.6429C18.592 6.76803 18.6547 6.92627 18.6547 7.11763V18.4638C18.6547 20.0892 18.0853 21.4713 16.9464 22.6102C15.8075 23.749 14.4254 24.3185 12.8 24.3185Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentS);
export default __webpack_public_path__ + "static/media/attachmentS.3dcd4b027c05220c0f7033fb616c7021.svg";
export { ForwardRef as ReactComponent };